var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.$modal.isVisible(_vm.USER_SCRIPTS_MODAL),"width":"900px","top":"5vh","close-on-click-modal":true,"before-close":_vm.closeModal}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h3',[_vm._v(_vm._s(_vm.$t('tabs.settings.userScripts')))])]),_c('UserScriptsForm',{on:{"close":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }